'use client';

import styles from './FleetBusiness.module.scss';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import FleetBusinessFrom from './Form/FleetBusinessFrom';

import * as yup from 'yup';
import FleetThankYouModal from './FleetThankYouModal/FleetThankYouModal';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import request from '../../../utils/request';
import { useLocation } from 'react-router-dom';
import { getJaecooSiteLang } from '../../../utils/cookie';

export default function FleetBusiness({ fields }) {
  const location = useLocation();

  // 获取当前语言
  const getCurrentLanguage = () => {
    const cookieLang = getJaecooSiteLang();
    if (cookieLang) return cookieLang;

    const path = location.pathname;
    if (path.startsWith('/en')) return 'en';
    if (path.startsWith('/nl')) return 'nl';
    if (path.startsWith('/be')) return 'be';
    return 'en';
  };

  const currentLang = getCurrentLanguage();

  // 荷兰本地手机号验证规则（英文版和荷兰版一致）
  const getPhoneValidation = () => {
    // 统一使用荷兰本地手机号验证：31开头，后面10位数字
    // return /^31\d{9}$/;
    // 动态生成手机号验证规则
    return (value) => {
      if (value.startsWith('32')) {
        // 32开头，后面8-11位数字
        return /^32\d{8,11}$/.test(value);
      } else if (value.startsWith('352')) {
        // 352开头，后面8-11位数字
        return /^352\d{8,11}$/.test(value);
      } else {
        // 不是31开头，只要求是数字即可，没有长度要求
        return /^\d+$/.test(value);
      }
    };
  };

  const schema = yup.object({
    role: yup.string().required(fields?.requiredMessage?.value),
    title: yup.string().required(fields?.requiredMessage?.value),
    firstName: yup.string().required(fields?.requiredMessage?.value),
    lastName: yup.string().required(fields?.requiredMessage?.value),
    email: yup
      .string()
      .email(fields?.emailVerification?.value)
      .required(fields?.requiredMessage?.value),
    phoneNumber: yup
      .string()
      .required(fields?.requiredMessage?.value)
      .test('valid-phone-number', fields.mobileNumberVerification?.value, getPhoneValidation()),
    // .matches(getPhoneValidation(), fields?.mobileNumberVerification?.value),
    company: yup.string().required(fields?.requiredMessage?.value),
    fleetSize: yup.string().required(fields?.requiredMessage?.value),
    businessPostcode: yup.string().required(fields?.requiredMessage?.value),
    enquiry: yup.string().required(fields?.requiredMessage?.value),
    termsAndConditionsCheck: yup.boolean().oneOf([true], fields?.requiredMessage?.value).required(),
  });
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resultType, setResultType] = useState(false);

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });
  const onSubmit = async (data) => {
    if (isSubmitting) return; // 防止重复提交

    setIsSubmitting(true);

    try {
      // 删除  termsAndConditionsCheck  字段
      delete data.termsAndConditionsCheck;
      const result = await request.post('/api/sitecore/cars/fleetsubmit', data);
      // console.log(result, 'submit success');
      setShowModal(true);
      if (result.code === 200) {
        setResultType(true);
      } else {
        setResultType(false);
      }
    } catch (error) {
      console.error('提交失败:', error);
      // 可以在这里添加错误提示
      setShowModal(true);
      setResultType(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setResultType(false);
    methods.reset();
  };
  return (
    <div className={'container'}>
      <div className={styles.wrapper}>
        <div className={styles.main}>
          <h2 className={styles.title}>{fields?.formTitle?.value}</h2>
          <FormProvider {...methods}>
            <form noValidate onSubmit={methods.handleSubmit(onSubmit)} className={styles.form}>
              <FleetBusinessFrom fields={fields} isSubmitting={isSubmitting} />
            </form>
          </FormProvider>
        </div>
        <div className={styles.imageContainer}>
          <Image field={fields.carImageMobile}></Image>
        </div>
        <div className={styles.imageContainerTablet}>
          <Image field={fields.carImageDesktop}></Image>
        </div>
        <FleetThankYouModal
          visible={showModal}
          onClose={handleCloseModal}
          fields={fields}
          result={resultType}
        />
      </div>
    </div>
  );
}
